module.exports = __webpack_public_path__ + "img/simb-menos-gris.913f69ae.svg";